import {
  Box,
  Button,
  Chip,
  Grid,
  List,
  Slide,
  TextField,
  Typography,
  Tabs,
  Tab
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
import "../card.css";
import PropTypes from 'prop-types';
import InUserProfile from "../components/InUserProfile";
import InMyAccount from "./InMyAccount";
import DashboardWidgets from "../components/DashboardWidgets";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? 'rgba(26, 32, 39, 0.5)' : 'rgba(255, 255, 255, 0.2)',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  borderRadius: '8px',
}));

function SlideTransition(props) {
  return <Slide {...props} direction="up" />;
}

export const Settings = ({isOnline}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const again = location.state && location.state.again;
  const [roleValue, setRoleValue] = useState("");
  const [allRoles, setAllRoles] = useState([]);
  const [viewPermissions, setViewPermissions] = useState();
  const [currentRoles, setCurrentRoles] = useState([]);
  const [personaInfo, setPersonaInfo] = useState([]);
  const [detailsInfo, setDetailsInfo] = useState([]); 
  const [value1, setValue1] = useState(0);
  const go = location.state && location.state.go;
  

  const fetchPersona = () => {
    const storedPersona = localStorage.getItem('persona_info');
  
    if (!isOnline) {
      setPersonaInfo(JSON.parse(storedPersona));
    } else {
      api.get('/users/su', {
        headers: {
          Authorization: 'Bearer ' + fetchToken(),
        },
      })
        .then(function (response) {
          setPersonaInfo(response.data);
          localStorage.setItem('persona_info', JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

    const fetchUserDetailAll = () =>{
      api.get('/users/details/all',{
          headers: {
              Authorization: 'Bearer '+ fetchToken()
          }
        }).then(function (response){
            setDetailsInfo(response.data?.details);
        }).catch(function (error){
          console.log(error)
        })
    }
  
    useEffect(() => {
      fetchPersona();
      fetchUserDetailAll();
    }, [])


    if(go === "Go"){
      setValue1(2)
    }
 

  const handleChange1 = (event, newValue) => {
    setValue1(newValue);
  };

  const fetchRoles = () => {
    api
      .get("/auth/all/roles", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setAllRoles(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleNewRole = () => {
    const data = new FormData();
    data.append("role_name", roleValue);

    api
      .post("/users/new/role", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
        setRoleValue("");
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        fetchRoles();
      });
  };

  const handlePermission = (role_id, role_name) => {
    api
      .get(`/permissions/${role_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setCurrentRoles(response.data?.Data);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        if (currentRoles.length > 0) {
          navigate("/permissions", {
            state: {
              role_id: role_id,
              role_name: role_name,
              currentRoles: currentRoles,
            },
          });
        } else if (currentRoles.length <= 0) {
          toast.info("Click again to open");
        }
      });
  };
  const [holdId, setHoldId] = useState();
  const [openn, setOpenn] = useState(null);

  const prepare = (id) => {
    setHoldId(id);
    setOpenn(true);
  };

  const handleClose = () => {
    setOpenn(false);
  };

  const handleDelete = () => {
    api
      .delete(`/users/delete/${holdId}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        fetchRoles();
        setHoldId();
        handleClose();
      });
  };

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 3 }}>
          
          <Grid container spacing={1}>
            <Grid item xs={12} md={2}>
              <Tabs sx={{ position: 'fixed' }} value={value1} orientation='vertical' variant='scrollable' onChange={handleChange1} aria-label="basic tabs example">
                <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Roles & Permissions</b>} {...a11yProps(0)} />
                <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Dashboard Widgets</b>} {...a11yProps(1)} />
                <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>My Profile</b>} {...a11yProps(2)} />
                <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>My Account</b>} {...a11yProps(3)} />
              </Tabs>
            </Grid>
            <Grid item xs={12} md={10}>
              {/* Roles & Permission */}
              <CustomTabPanel value={value1} index={0}>
                  {/* create roles */}
                  <Box sx={{ mb:5, ml:10, mr:10 }}>
                    <Item>

                      <Typography
                        variant="h4"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        sx={{ textAlign: "center", color: "darkblue", mb: 2, mt: 2 }}
                      >
                        Create Roles
                      </Typography>
                      <TextField
                        size="small"
                        sx={{ marginLeft: 2 }}
                        variant="standard"
                        label="Role"
                        value={roleValue}
                        onChange={(e) => setRoleValue(e.target.value)}
                        type="text"
                      />
                      <Box>
                        <Button
                          variant="contained"
                          onClick={() => setRoleValue("")}
                          sx={{ backgroundColor: "#bc6c25", color: "#fff", margin: 2 }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          onClick={handleNewRole}
                          sx={{ backgroundColor: "#9e2a2b", color: "#fff" }}
                        >
                          Create
                        </Button>
                      </Box>
                    </Item>
                  </Box>
                  
                  {/* all roles */}
                  <Box sx={{ mb:10, ml:10, mr:10 }}>
                    <Item>
                      <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="h4"
                        sx={{ textAlign: "center", color: "darkblue", mt: 2 }}
                      >
                        All User Roles
                      </Typography>
                      <Typography
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="h6"
                        sx={{ textAlign: "center", color: "darkblue", mb: 2, mt: 1 }}
                      >
                        Click on role to manage it's settings
                      </Typography>
                      <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {allRoles.map((item) => (
                          <Chip
                            onDelete={() => prepare(item.id)}
                            key={item.id}
                            label={item.role_name}
                            onClick={() => handlePermission(item.id, item.role_name)}
                            variant="outlined"
                            color="success"
                            style={{ margin: "4px" }}
                          />
                        ))}
                      </div>
                    </Item>
                  </Box>
                  <Dialog
                    open={openn}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">{"Delete Role"}</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        This action is irreversible. Please note that it will also reset
                        the roles of users with empty roles.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleClose}>Cancel</Button>
                      <Button onClick={handleDelete} autoFocus>
                        Continue
                      </Button>
                    </DialogActions>
                  </Dialog>
              </CustomTabPanel>

              {/* Dashboard Widgets */}
              <CustomTabPanel value={value1} index={1}>
                 <DashboardWidgets isOnline={isOnline} />
              </CustomTabPanel>

              {/* My Profile */}
              <CustomTabPanel value={value1} index={2}>
                <InUserProfile readypersonaInfo={personaInfo} readydetailsInfo={detailsInfo} />
              </CustomTabPanel>
              
              {/* My Account */}
              <CustomTabPanel value={value1} index={3}>
                <InMyAccount />
              </CustomTabPanel>
            </Grid>
          </Grid>

          

          
        </Box>
      </main>
    </div>
  );
};



